/**
 * telegram-group service
 */

import {factories} from '@strapi/strapi';
import { Chat } from 'telegraf/typings/core/types/typegram';

const UID = 'plugin::telegram-bot.telegram-group';

export enum SynchronizationStatus {
  PENDING = 'pending',
  SYNCING = 'syncing',
  SYNCED = 'synced',
}

const TelegramGroupService = factories.createCoreService(UID, ({strapi}) => ({
  wallet: strapi.plugin('blockchain').service('walletService'),
  async upsertGroup(chat: Chat.SupergroupChat | Chat.ChannelChat, botInfo: any) {
    const existed = await strapi.db.query(UID).findOne({
      where: {
        telegram_id: chat.id,
      },
      populate: ['evm_wallet']
    });

    if (existed) {
      strapi.log.info(`Group with name ${chat.title} is already registered`);

      return existed;
    } else {
      const wallet = await this.wallet.generateNew(`${chat.id} | ${chat.title || ''}`);
      const group = await strapi.documents(UID).create({
        populate: ['evm_wallet'],
        data: {
          telegram_id: chat.id,
          name: chat.title,
          type: chat.type,
          bot_metadata: botInfo,
          evm_wallet: {
            set: [wallet['id']]
          }
        }
      })

      strapi.log.info(`New group with name ${chat.title} has been created`);

      return group;
    }
  },
  async getGroupByTelegramId(telegramId: number | string) {
    if (!telegramId) return null;

    if (typeof telegramId === 'string') telegramId = parseInt(telegramId, 10);

    const group = await strapi.db.query(UID).findOne({
      where: {
        telegram_id: telegramId,
      },
      populate: ['evm_wallet']
    });

    return group;
  },
  async updateSynchronizationStatus(documentId: string, status: SynchronizationStatus) {
    await strapi.db.query(UID).update({
      where: {
        documentId
      },
      data: {
        synchronization_status: status
      }
    });
  }
}));

export type TelegramGroupServiceType = typeof TelegramGroupService;

export default TelegramGroupService;
